import Button from '@ixigo/iui/Button';
import Typography from '@ixigo/iui/Typography';
import { useEffect } from 'react';
import { isMobile } from '../utils/common';
import logger from '../utils/logger';

const NotFound = () => {
    const isMobileDevice = isMobile();

    useEffect(() => {
        logger({ id: 'PAGE-NOT-FOUND', url: window.location.pathname });
    }, []);

    return (
        <div className='flex flex-col justify-center items-center h-full px-20'>
            <img
                src='https://images.ixigo.com/image/upload/rail/24089105b90cdc7d3e6404e6ac053e81-zmvsx.png'
                alt='not-found'
                height={isMobileDevice ? 500 : 400}
                width={isMobileDevice ? 200 : 400}
                loading='eager'
            />
            <Typography className='text-center mb-4' variant='body-md'>
                Oops!
                <br />
                You seem to have reached the wrong destination.
                <br />
                We couldn&#39;t find the page you were looking for.
            </Typography>
            <Button
                size='md'
                className={`!rounded-[2px] font-500 ${isMobileDevice ? 'w-full' : ''}`}
                as='a'
                href='/support'
            >
                GO TO HOMEPAGE
            </Button>
        </div>
    );
};

export default NotFound;
